import React from 'react'
import 'core-js';
import 'abortcontroller-polyfill';
import ReactDOM from 'react-dom/client'
import { App } from './App'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />
)
